import { postMessage } from "./postMessage";

export const resizer = (el: Element) =>
  new ResizeObserver(() => {
    const { height } = el.getBoundingClientRect();
    postMessage("resize", { height });
  }).observe(el);
